import { Reservations } from './reservations';

// Booking v2, company events (SS-1290). The registration dialog is shared with the calendar, so its
// keys live here and the calendar bundle spreads them in.
export const CompanyEvents = {
  en: {
    ...Reservations.en,

    'Company events': 'Company events',
    Events: 'Events',
    'No events': 'No events',
    Spots: 'Spots',
    'Free spots': 'Free spots',
    Waves: 'Waves',
    'All waves': 'All waves',
    'Split into waves': 'Split into waves',
    'Hidden from online booking': 'Hidden from online booking',

    event_scheduled: 'Scheduled',
    event_completed: 'Finished',
    event_cancelled: 'Cancelled',

    'Event registrations': 'Event registrations',
    Registrations: 'Registrations',
    'No registrations': 'No registrations',
    'Add registration': 'Add registration',
    'Pick a wave to add a registration': 'Pick a wave to add a registration',
    'Cancel registration': 'Cancel registration',
    'Existing client': 'Existing client',
    Guest: 'Guest',
    'Guest name / phone': 'Guest name / phone',
    'Specialist comment': 'Specialist comment',
    Attendance: 'Attendance',
    'Confirm attendance': 'Confirm attendance',
    'Paid online': 'Paid online',
    'The purchased service is recognised on confirmation':
      '«{{service}}» is written off the moment attendance is confirmed.',
    'Place hold': 'Place hold',
    'Sell on the client card': 'Sell on the client card',
    'Nothing is charged — money for an event is a separate sale':
      'Nothing is written off — money for an event is taken as a separate reception sale.',
    'Edit event': 'Edit event',
  },
  uk: {
    ...Reservations.uk,

    'Company events': 'Події клубу',
    Events: 'Події',
    'No events': 'Подій немає',
    Spots: 'Місця',
    'Free spots': 'Вільних місць',
    Waves: 'Хвилі',
    'All waves': 'Усі хвилі',
    'Split into waves': 'Розділити на під-події (хвилі)',
    'Hidden from online booking': 'Прихована з онлайн-запису',

    event_scheduled: 'Запланована',
    event_completed: 'Завершена',
    event_cancelled: 'Скасована',

    'Event registrations': 'Реєстрації на подію',
    Registrations: 'Реєстрації',
    'No registrations': 'Реєстрацій немає',
    'Add registration': 'Додати учасника',
    'Pick a wave to add a registration': 'Оберіть хвилю, щоб додати учасника',
    'Cancel registration': 'Скасувати реєстрацію',
    'Existing client': 'Наявний клієнт',
    Guest: 'Гість',
    'Guest name / phone': 'Ім’я / телефон гостя',
    'Specialist comment': 'Коментар спеціаліста',
    Attendance: 'Відвідування',
    'Confirm attendance': 'Підтвердити відвідування',
    'Paid online': 'Оплачено онлайн',
    'The purchased service is recognised on confirmation':
      'Послугу «{{service}}» буде списано в момент підтвердження відвідування.',
    'Place hold': 'Бронь місця',
    'Sell on the client card': 'Продати на картці клієнта',
    'Nothing is charged — money for an event is a separate sale':
      'Нічого не списується — оплата за подію проводиться окремим продажем на рецепції.',
    'Edit event': 'Редагувати подію',
  },
};

export const CompanyEventForm = {
  en: {
    ...CompanyEvents.en,

    'New Event': 'New event',
    'Edit Event': 'Edit event',
    'Create Event': 'Create',
    'Update Event': 'Save',
    'Event name': 'Event name',
    'Start date': 'Start date',
    'Start time': 'Start time',
    'End date': 'End date',
    'End time': 'End time',
    'Available for online booking': 'Available for online booking',
    'Locked once someone has registered': 'Locked once someone has registered',
    'Saving now deletes every wave of this event':
      'Saving now deletes every wave of this event',
    'Event service': 'Event service',
    Capacity: 'Participants limit',
    'Save the event for the split to take effect':
      'Save the event for the split to take effect',
    'Waves are created together with the event':
      'Waves are created together with the event',
    'Add wave': 'Add wave',
    'Edit wave': 'Edit wave',
    'Delete wave': 'Delete wave',
    'No waves yet': 'No waves yet',
    'Wave name': 'Wave name',
    'A wave runs inside the event span; waves may overlap.':
      'A wave runs inside the event span; waves may overlap.',
  },
  uk: {
    ...CompanyEvents.uk,

    'New Event': 'Нова подія',
    'Edit Event': 'Редагування події',
    'Create Event': 'Створити',
    'Update Event': 'Зберегти',
    'Event name': 'Назва події',
    'Start date': 'Дата початку',
    'Start time': 'Час початку',
    'End date': 'Дата завершення',
    'End time': 'Час завершення',
    'Available for online booking': 'Доступна для онлайн-запису',
    'Locked once someone has registered': 'Недоступно після першої реєстрації',
    'Saving now deletes every wave of this event':
      'Збереження видалить усі хвилі цієї події',
    'Event service': 'Послуга події',
    Capacity: 'Кількість учасників',
    'Save the event for the split to take effect':
      'Щоб розділення запрацювало, збережіть подію',
    'Waves are created together with the event':
      'Хвилі створюються разом із подією',
    'Add wave': 'Додати хвилю',
    'Edit wave': 'Редагувати хвилю',
    'Delete wave': 'Видалити хвилю',
    'No waves yet': 'Хвиль ще немає',
    'Wave name': 'Назва хвилі',
    'A wave runs inside the event span; waves may overlap.':
      'Хвиля має вміщатися в час події; хвилі можуть перетинатися.',
  },
};
